<ng-template #cardTemplate>
  <app-user-slot *ngFor="let user of list.items | async" [user]="user"></app-user-slot>
</ng-template>

<ng-template #tableTemplate>
  <eas-table [table]="list.table | async" [defaultColumns]="defaultColumns"></eas-table>
</ng-template>

<app-list title="Users" i18n-title
          [actions]="actions"
          [cardTemplate]="cardTemplate"
          [tableTemplate]="tableTemplate"></app-list>

